export default "__VITE_ASSET__Dp_PqN93__"